import { render } from "./CalWeekReview.vue?vue&type=template&id=271e3da4"
import script from "./CalWeekReview.vue?vue&type=script&lang=js"
export * from "./CalWeekReview.vue?vue&type=script&lang=js"

import exportComponent from "/Users/johnahnz0rs/0-PROJECTS/stackin-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__